export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11252.d5ceb9a6.jpg";